import React, { useMemo } from 'react';
import { Drawer } from '@mui/material';
import { AthleteActivityPanel } from './AthleteActivityPanel';
import { AthleteActivityItem } from './athleteActivityStats';
import { ReviewSuspiciousHandler } from './AthleteActivityIntegrity';
import { ContestActivityIntegrity } from '../../models/types';

interface Activity extends ContestActivityIntegrity {
  activityId: string; // contest activity record id
  distance: number;
  pace: number;
  movingTime: number;
  workoutType: string;
  startDate: string;
  stravaActivityId?: number;
}

interface ActivityDetailsModalProps {
  open: boolean;
  onClose: () => void;
  userName: string;
  teamName: string;
  activities: Activity[];
  loading?: boolean;
  onReviewSuspicious?: ReviewSuspiciousHandler;
}

// Right-side athlete drawer; keeps the original dialog's open/onClose contract.
const ActivityDetailsModal: React.FC<ActivityDetailsModalProps> = ({ open, onClose, userName, teamName, activities, loading = false, onReviewSuspicious }) => {
  const items: AthleteActivityItem[] = useMemo(
    () => activities.map((a, i) => ({ ...a, id: a.activityId || String(i) })),
    [activities]
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: 'min(100%, 480px)', backgroundColor: 'var(--card)', backgroundImage: 'none', borderLeft: '1px solid var(--border)' } }}
    >
      <AthleteActivityPanel name={userName} subtitle={teamName || undefined} activities={items} loading={loading} onClose={onClose} fill onReviewSuspicious={onReviewSuspicious} />
    </Drawer>
  );
};

export default ActivityDetailsModal;
